module.exports = {
	awsAuthApiId: '64pwg4r6k7',
	awsHostedZoneId: 'Z00480842602ZBRG3ZE7C',
	paypalClientId: 'AVhkLWxMBF67byO1vI3JE93pRsE67h0Yepg3QKUfFwSKPWi9EGQG9k-SrMH_0Jt8qRdymen4nvQY4IeI',
	twitchClientId: 'cl378bbgnhl46y11c5nh2dkihsiwng',
	twitchOverlayClientId: 'qifu955ljtc5q28vqgug1unde06xv5',
	twitchPanelClientId: 'b4aopezvsf74kg00pxp0ye6szrdobc',
	youtubeApiKeyClient: 'AIzaSyBCvQZtb567voI9vZcjAtew5QZ19F-2lQk',
	secretArns: [
		'arn:aws:secretsmanager:us-east-1:685544790364:secret:PayPal_Test-D0yqz5',
		'arn:aws:secretsmanager:us-east-1:685544790364:secret:developmentTwitchSecret-OFK2hH',
		'arn:aws:secretsmanager:us-east-1:685544790364:secret:developmentYoutubeOAuth-DLs4FG',
		'arn:aws:secretsmanager:us-east-1:685544790364:secret:developmentGoogle-ayZV6O',
		'arn:aws:secretsmanager:us-east-1:685544790364:secret:tiktokOauthSecretDev-aaiKEN',
		'arn:aws:secretsmanager:us-east-1:685544790364:secret:paypalApiCertificateDev-ff6eVE',
		'arn:aws:secretsmanager:us-east-1:685544790364:secret:cryptoDevelopment-28LCEz',
		'arn:aws:secretsmanager:us-east-1:685544790364:secret:twitchPanelSecret-JPmK6o',
		'arn:aws:secretsmanager:us-east-1:685544790364:secret:twitchOverlaySecret-yOGUql',
		'arn:aws:secretsmanager:us-east-1:918224642237:secret:steamWebAPISecrets-jYATeY',
	],
}
